module.exports = __webpack_public_path__ + "img/Close - Pink.313fb2f5.png";